import type { TOverriddenChannelsData } from "components/TitleFormContainer/types";
import type { ITitle } from "containers/Titles/types";
import type { TPortalType } from "store/types";
import type { SubsetOf } from "types";

export type TFilteredData = {
    countryMarketChannelById: TTitleCountryMarketData;
};

export type TTitleCountryMarketData = Record<number, TOverriddenChannelsData[]>;

/**
 * Format data Title channels overridenChannelsData to have all channels country market by channel ID
 * like this object : { [channelId]: [...{channelWithCountryMarket}] }
 * @param { ITitle } title current title data
 * @param { "book" | "beneficiary" } portalType if function called from publisher or beneficiary portal
 */
export const getCountryMarketData = (
    title: ITitle | null,
    portalType: SubsetOf<TPortalType, "book" | "beneficiary">,
) => {
    const titleChannelsKey = {
        book: "overriddenChannelsData",
        beneficiary: "channels",
    };

    const channels = titleChannelsKey[portalType];

    if (title?.id)
        return title?.[channels]?.reduce(
            (filteredData: TFilteredData, channel: TOverriddenChannelsData, _index) => {
                if (channel.countryMarket) {
                    if (filteredData.countryMarketChannelById[channel.channelId]) {
                        filteredData.countryMarketChannelById[channel.channelId].push(channel);
                    } else {
                        filteredData.countryMarketChannelById[channel.channelId] = [channel];
                    }
                }
                return filteredData;
            },
            { countryMarketChannelById: {} },
        );
};
